module.exports = __webpack_public_path__ + "static/media/paske-2.5485e626.jpg";